<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-7">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label"></label>
                  <div class="col-md-8">
                    <ts-button color="info" outline @click="fromInquiry">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.fromInquiry'
                        )
                      }}
                    </ts-button>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.nameKh'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <fieldset>
                      <div class="row form-group">
                        <div class="col-md-6">
                          <input type="text" ref="first_name_kh" v-model.trim="model.first_name_kh" class="form-control"
                            :class="{
                              'is-invalid': errors.has('first_name_kh')
                            }"
                            :placeholder="
                              $t(
                                'school.academic.operation.profile_mgt.studentProfile.firstName'
                              )
                            "
                          />
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('first_name_kh')"
                          >
                            {{ errors.first('first_name_kh') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <input
                            type="text"
                            v-model.trim="model.last_name_kh"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('last_name_kh')
                            }"
                            :placeholder="
                              $t(
                                'school.academic.operation.profile_mgt.studentProfile.lastName'
                              )
                            "
                          />
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('last_name_kh')"
                          >
                            {{ errors.first('last_name_kh') }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <input type="text" class="form-control" readonly :value="fullNameKh" :placeholder="$t(
                            'school.academic.operation.profile_mgt.studentProfile.fullNameKh'
                          )
                            " />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label required">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.nameEn'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <fieldset>
                      <div class="row form-group">
                        <div class="col-md-6">
                          <input
                            type="text"
                            v-model.trim="model.first_name_en"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                errors.has('first_name_en') ||
                                $v.model.first_name_en.$error
                            }"
                            :placeholder="
                              $t(
                                'school.academic.operation.profile_mgt.studentProfile.firstName'
                              )
                            "
                          />
                          <span
                            class="invalid-feedback"
                            v-if="lastNameEnErrors.length > 0"
                            >{{ lastNameEnErrors[0] }}</span
                          >
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('first_name_en')"
                          >
                            {{ errors.first('first_name_en') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <input
                            type="text"
                            v-model.trim="model.last_name_en"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                errors.has('last_name_en') ||
                                $v.model.last_name_en.$error
                            }"
                            :placeholder="
                              $t(
                                'school.academic.operation.profile_mgt.studentProfile.lastName'
                              )
                            "
                          />
                          <span
                            class="invalid-feedback"
                            v-if="firstNameEnErrors.length > 0"
                            >{{ firstNameEnErrors[0] }}</span
                          >
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('last_name_en')"
                          >
                            {{ errors.first('last_name_en') }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <input type="text" class="form-control" readonly :value="fullNameEn" :placeholder="$t(
                            'school.academic.operation.profile_mgt.studentProfile.fullNameEn'
                          )
                            " />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label required">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.gender'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <div>
                      <div class="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="male"
                          v-model="model.gender"
                          value="Male"
                          @input="$v.model.gender.$touch()"
                          :class="{
                            'is-invalid':
                              errors.has('gender') || $v.model.gender.$error
                          }"
                        />
                        <label for="male">Male</label>
                      </div>
                      <div class="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="female"
                          v-model="model.gender"
                          value="Female"
                          @input="$v.model.gender.$touch()"
                          :class="{
                            'is-invalid':
                              errors.has('gender') || $v.model.gender.$error
                          }"
                        />
                        <label for="female">Female</label>
                      </div>
                      <br />
                      <span class="validate" v-if="genderErrors.length > 0">{{
                        genderErrors[0]
                      }}</span>
                      <div class="invalid-feedback" v-if="errors.has('gender')">
                        {{ errors.first('gender') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label required">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.studentType'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <div class="ts-flex ts-justify-between">
                      <div>
                        <ts-checkbox v-model="model.is_student">{{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.isStudent'
                          )
                        }}</ts-checkbox>
                      </div>
                      <div>
                        <ts-checkbox v-model="model.is_external_candidate" @change="onChangeIsExternal">{{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.isExternalCandidate'
                          )
                        }}</ts-checkbox>
                      </div>
                    </div>
                    <div class="text-danger" v-if="errors.has('is_student')">
                      {{ errors.first('is_student') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-date-picker-input v-model="model.date_of_birth" />
                    <div v-if="errors.has('date_of_birth')" class="validate">
                      {{ errors.first('date_of_birth') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.nationality'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <treeselect :load-options="loadNationalityOptions" :options="nationalityOptions"
                      :placeholder="$t('typeForSearch')" v-model="model.nationality" />
                    <div v-if="errors.has('nationality')" class="validate">
                      {{ errors.first('nationality') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.religion'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <treeselect
                      :load-options="loadReligionOptions"
                      :options="religionOptions"
                      :placeholder="$t('typeForSearch')"
                      v-model="model.religious"
                    />
                    <div v-if="errors.has('religious')" class="validate">
                      {{ errors.first('religious') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.registerDate'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-date-picker-input v-model="model.registered_date" />
                    <span class="validate" v-if="registeredDateErrors.length > 0">{{ registeredDateErrors[0] }}</span>
                    <div v-if="errors.has('registered_date')" class="validate">
                      {{ errors.first('registered_date') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.parent'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <div class="ts-flex">
                      <ts-select-parent v-model.number="model.student_parent_id" style="width: 320px;"
                        :new-profile="newProfileOption" />
                      <a class="btn btn-info" v-tooltip="$t('add')" @click.prevent="() => (show_form = true)">
                        <i class="fas fa-plus ts-text-white"></i>
                      </a>
                      <a-modal v-if="show_form" v-model="show_form"
                        :title="$t('school.academic.operation.profile_mgt.studentProfile.parent')" centered
                        :maskClosable="false" :zIndex="1020" @click="showFormParent()" :footer="null" width="900px">
                        <form-component-parent @cancel="onCancel" @onCreated="onParentCreated" />
                      </a-modal>
                    </div>
                    <div class="invalid-feedback" v-if="errors.has('student_parent_id')">
                      {{ errors.first('student_parent_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.serialFingerPrint'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      v-model.trim="model.serial_finger_print_no"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('serial_finger_print_no')
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('serial_finger_print_no')"
                    >
                      {{ errors.first('serial_finger_print_no') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <ts-image-input
                  :title="
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.uploadPhoto'
                    )
                  "
                  :file="file"
                  @input="file => (model.photo = file)"
                  :width="175"
                  :height="225"
                  crop
                ></ts-image-input>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <ts-button @click="takePicture">
                  <i class="fas fa-camera mr-2"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.takePhoto'
                    )
                  }}
                </ts-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import WebCam from './web-cam'
import FromInquiry from './from-inquiry'
import { required } from 'vuelidate/lib/validators'
import TsSelectParent from '@/components/SelectParent'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import FormComponentParent from './form-parent.vue'

export default {
  name: 'profile-information-form',
  props: ['value', 'validate', 'clear'],
  components: {
    TsSelectParent
  },
  data () {
    return {
      model: {},
      waiting: false,
      show_form: false,
      loadingPreData: false,
      nationalityOptions: null,
      religionOptions: null,
      errors: new Errors(),
      file: require('../../../assets/user_default.png')
    }
  },
  async created () {
    this.model = this.value
    await this.setEditData()
    this.$refs.first_name_kh.focus()
  },
  validations: {
    model: {
      first_name_en: { required },
      last_name_en: { required },
      gender: { required },
      registered_date: { required }
    },
    form: [
      'model.first_name_en',
      'model.last_name_en',
      'model.gender',
      'model.registered_date'
    ]
  },
  computed: {
    ...mapState('studentProfile', [
      'genders',
      'nationalities',
      'religions',
      'photoBlob',
      'edit_data'
    ]),
    fullNameKh () {
      return (
        (this.model.first_name_kh ? this.model.first_name_kh : '') +
        (this.model.last_name_kh ? ' ' + this.model.last_name_kh : '')
      )
    },
    fullNameEn () {
      return (
        (this.model.first_name_en ? this.model.first_name_en : '') +
        (this.model.last_name_en ? ' ' + this.model.last_name_en : '')
      )
    },
    firstNameEnErrors () {
      const errors = []
      if (!this.$v.model.first_name_en.$error) return errors
      !this.$v.model.first_name_en.required && errors.push('Required')
      return errors
    },
    lastNameEnErrors () {
      const errors = []
      if (!this.$v.model.last_name_en.$error) return errors
      !this.$v.model.last_name_en.required && errors.push('Required')
      return errors
    },
    genderErrors () {
      const errors = []
      if (!this.$v.model.gender.$error) return errors
      !this.$v.model.gender.required && errors.push('Required')
      return errors
    },
    registeredDateErrors () {
      const errors = []
      if (!this.$v.model.registered_date.$error) return errors
      !this.$v.model.registered_date.required && errors.push('Required')
      return errors
    }
  },
  methods: {
    ...mapActions('studentProfile', ['fetchNationality', 'fetchReligion']),

    validateForm () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      return isValid
    },
    async getNationality () {
      this.loadingPreData = true
      this.nationalityOptions = null
      let response = await this.fetchNationality()
      this.nationalityOptions = response.data.map(el => ({
        id: el.id,
        label: el.nationality
      }))
      this.loadingPreData = false
    },
    async getReligion () {
      this.religionOptions = null
      let response = await this.fetchReligion()
      this.religionOptions = response.data.map(el => ({
        id: el.id,
        label: el.religion
      }))
    },
    async loadNationalityOptions ({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getNationality()
      }
    },
    async loadReligionOptions ({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getReligion()
      }
    },
    fromInquiry () {
      this.$modal.show(
        FromInquiry,
        { value: this.value },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          clickToClose: false
        }
      )
    },
    takePicture () {
      this.$modal.show(
        WebCam,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          clickToClose: false
        },
        {
          'before-close': this.getPhoto
        }
      )
    },
    getPhoto () {
      this.file = this.readBlob(this.photoBlob)
      this.model.photo = new File([this.photoBlob], 'photo', {
        type: 'image/jpeg'
      })
      this.$store.commit('studentProfile/SET_PHOTO_BLOB', '')
    },
    readBlob (blob) {
      return window.URL.createObjectURL(
        new Blob([blob], { type: 'image/jpeg' })
      )
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.getNationality()
        this.getReligion()
        this.$store.commit(
          'studentProfile/SET_PARENT_SEARCH',
          this.edit_data.parent ? this.edit_data.parent.father_name_en : ''
        )
        this.model.student_id = this.edit_data.student_id
        this.model.last_name_kh = this.edit_data.last_name_kh
        this.model.first_name_kh = this.edit_data.first_name_kh
        this.model.last_name_en = this.edit_data.last_name_en
        this.model.first_name_en = this.edit_data.first_name_en
        this.model.gender = this.edit_data.gender
        this.model.date_of_birth = this.edit_data.date_of_birth
        this.model.nationality = this.edit_data.nationality
        this.model.religion = this.edit_data.religious
        this.model.registered_date = this.edit_data.registered_date
        this.model.student_parent_id = this.edit_data.student_parent_id
        this.model.serial_finger_print_no = this.edit_data.serial_finger_print_no
        this.model.is_external_candidate = this.edit_data.is_external_candidate
        this.model.is_student = this.edit_data.is_student
        this.model.photo = this.edit_data.photo
        this.file = this.model.photo
      }
    },
    onChangeIsExternal(val){
      if (val) {
        this.model.is_student = false
      } else {
        this.model.is_student = true
      }
    }
  },
  watch: {
    validate: {
      handler () {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function (value) {
      if (value == true) {
        this.model = this.value
        this.file = ''
      }
    }
  }
}
</script>
<style lang="css" scoped>
.file-input-container {
  width: 174px !important;
  margin: 0 auto;
  border: 1px solid #eaeaea;
  padding: 4px;
  border-radius: 5px;
}

fieldset {
  border: 1px solid #17a2b8;
}
</style>
